export default __webpack_public_path__ + "static/media/wsr_wiiwg_o.d0a86847.png";